import { Component, Input, output } from '@angular/core';

import { ColorPickerColorComponent } from '../color-picker-color/color-picker-color.component';

@Component({
  selector: 'bn-web-ui-color-picker-colors',
  templateUrl: './color-picker-colors.component.html',
  imports: [ColorPickerColorComponent],
})
export class ColorPickerColorsComponent {
  @Input()
  public colors: string[] = [];

  @Input()
  public selectedColor?: string;

  readonly onColorClick = output<string>();

  public handleColorClick(color: string): void {
    this.onColorClick.emit(color);
  }

  public trackByItemIndex(index: number): number {
    return index;
  }
}
